import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInbox } from "@fortawesome/pro-regular-svg-icons";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  container: {
    padding: 0,
  },

  empty: {
    fontWeight: 600,
  },

  inbox: {
    color: theme.palette.primary.darker,
  },
}));

const Empty = ({ message = "This group is empty" }) => {
  const classes = useStyles();
  return (
    <Grid
      className={classes.container}
      style={{ paddingTop: 75 }}
      container
      direction="column"
      alignItems="center"
      spacing={2}
    >
      <Grid item>
        <FontAwesomeIcon className={classes.inbox} icon={faInbox} size="8x" />
      </Grid>

      <Grid item>
        <Typography className={classes.empty}>{message}</Typography>
      </Grid>

      {/* <Grid item>
            <Button
              onClick={handleClick}
              color="primary"
              variant="contained"
              style={{ width: "auto" }}
              aria-label="Go to Organize home screen"
            >
              Start Organizing
            </Button>
          </Grid> */}
    </Grid>
  );
};

export default Empty;
